import React from 'react';

function CustomFieldsSection({ 
  customFields, 
  newFieldName, 
  setNewFieldName, 
  newFieldType, 
  setNewFieldType, 
  handleAddCustomField, 
  handleDeleteCustomField,
  defaultFields,
  hiddenFields,
  handleToggleDefaultField,
  handleEditFieldLabel
}) {
  return (
    <div className="admin-section">
      <div className="section-header">
        <h1>Custom Fields Manager</h1>
      </div>

      <div className="form-card">
        <h3>Add New Field</h3>
        <div className="form-row">
          <div className="form-field">
            <label>Field Name</label>
            <input
              type="text"
              placeholder="e.g. warranty, color"
              value={newFieldName}
              onChange={(e) => setNewFieldName(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label>Field Type</label>
            <select value={newFieldType} onChange={(e) => setNewFieldType(e.target.value)}>
              <option value="text">Text</option>
              <option value="number">Number</option>
              <option value="textarea">Textarea</option>
              <option value="email">Email</option>
              <option value="url">URL</option>
              <option value="date">Date</option>
              <option value="tel">Phone</option>
              <option value="color">Color</option>
              <option value="select">Dropdown</option>
              <option value="checkbox">Checkbox</option>
            </select>
          </div>
        </div>
        <button className="btn-primary" onClick={handleAddCustomField}>
          + Add Field
        </button>
      </div>

      <div className="data-table">
        <h3>Default Fields</h3>
        <table>
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {defaultFields.map((field) => (
              <tr key={field.id}>
                <td><strong>{field.label}</strong></td>
                <td>{field.type}</td>
                <td>
                  <span style={{color: hiddenFields.includes(field.id) ? '#ff4444' : '#4caf50'}}>
                    {hiddenFields.includes(field.id) ? 'Hidden' : 'Visible'}
                  </span>
                </td>
                <td>
                  <div style={{display: 'flex', gap: '8px'}}>
                    <button 
                      className="btn-primary" 
                      style={{padding: '6px 12px', fontSize: '12px'}}
                      onClick={() => handleEditFieldLabel(field, true)}
                    >
                      ✏️ Edit
                    </button>
                    <button 
                      className="btn-secondary" 
                      style={{padding: '6px 12px', fontSize: '12px'}}
                      onClick={() => handleToggleDefaultField(field.id)}
                    >
                      {hiddenFields.includes(field.id) ? '👁️ Show' : '🚫 Hide'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="data-table" style={{marginTop: '24px'}}>
        <h3>Custom Fields</h3>
        <table>
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {customFields.length === 0 ? (
              <tr>
                <td colSpan="3" style={{textAlign: 'center', padding: '40px'}}>No custom fields yet</td>
              </tr>
            ) : (
              customFields.map((field) => (
                <tr key={field.id}>
                  <td><strong>{field.label}</strong></td>
                  <td>{field.type}</td>
                  <td>
                    <div style={{display: 'flex', gap: '8px'}}>
                      <button 
                        className="btn-primary" 
                        style={{padding: '6px 12px', fontSize: '12px'}}
                        onClick={() => handleEditFieldLabel(field, false)}
                      >
                        ✏️ Edit
                      </button>
                      <button 
                        className="btn-secondary" 
                        style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                        onClick={() => handleDeleteCustomField(field.id)}
                      >
                        🗑️ Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CustomFieldsSection;
